import { render, staticRenderFns } from "./new-partner-pricing-product.vue?vue&type=template&id=42316e0b&scoped=true&"
import script from "./new-partner-pricing-product.vue?vue&type=script&lang=js&"
export * from "./new-partner-pricing-product.vue?vue&type=script&lang=js&"
import style0 from "./new-partner-pricing-product.vue?vue&type=style&index=0&id=42316e0b&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "42316e0b",
  null
  
)

export default component.exports